import {
	FxIdDomainStoreEnumsSupportedWebPublishingPlatform,
	type FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiLogin,
	type FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin
} from "../Api/gen";

export type OdnoklassnikiLoginOptions =
	| { OdnoklassnikiLogin: FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiLogin }
	| {
			OdnoklassnikiViaVkontakteLogin: FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin;
	  };

export function isOdnoklassnikiLaunch(search: string): boolean {
	const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
	return params.get("vk_client")?.toLowerCase() === "ok";
}

export function resolveWebPublishingPlatform(
	configured: FxIdDomainStoreEnumsSupportedWebPublishingPlatform,
	search: string
): FxIdDomainStoreEnumsSupportedWebPublishingPlatform {
	return configured === FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontakteCom && isOdnoklassnikiLaunch(search)
		? FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki
		: configured;
}

export function odnoklassnikiLoginOptionsFor(search: string): OdnoklassnikiLoginOptions {
	return isOdnoklassnikiLaunch(search)
		? { OdnoklassnikiViaVkontakteLogin: { QueryString: search } }
		: { OdnoklassnikiLogin: { QueryString: search } };
}
